import { render, staticRenderFns } from "./UsersView.vue?vue&type=template&id=24ccc8e1&lang=pug&"
import script from "./UsersView.vue?vue&type=script&lang=js&"
export * from "./UsersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports